import React from "react";
import { ListItem, ListItemProps } from "@emisgroup/ui-list";

/**
 * Responsible for rendering the items in List
 * @returns list elements
 */
export const UIListItem: React.FC<ListItemProps> = (props: ListItemProps) => {

  const { children } = props;

  return (
    <ListItem
      {...props}
    >
      {children}
    </ListItem>
  );
};
